import React, { Component } from "react";
import Header from "./Header";
import CallCenterEmailForm from "./CallCenterEmailForm";
import Footer from "./Footer";
import EmailConfirmation from "./EmailConfirmation";
import BadRequest from "./BadRequest";
import InternalServerError from "./InternalServerError";
import DuplicateRequest from "./DuplicateRequest";
import SpinnerLoad from "./SpinnerLoad";
import axios from "axios";
import CryptoJS from "crypto-js";

class CallCenterEmail extends Component {
  constructor() {
    super();
    this.state = {
      requestForm: true,
      emailConfirm: false,
      badRequest: false,
      internalServerError: false,
      duplicateRequest: false,
      duplicateRequestMsg: "",
    };
    this.onParentAppCall = this.onParentAppCall.bind(this);
  }

  async onParentAppCall(formData) {
    var obj = {
      url: process.env.REACT_APP_DPR_API_URL + "/DSARRequestNew",
      body: CryptoJS.AES.encrypt(
        JSON.stringify(formData),
        this.props.password
      ).toString(),
      method: "POST",
    };

    try {
      const response = await axios({
        url: "/servercall/DPRAPI",
        method: "POST",
        data: obj,
      });
      this.setState({ requestForm: false });

      let bytes = CryptoJS.AES.decrypt(response.data, this.props.password);
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      if (decryptRes.status === "Request Received") {
        this.setState({ emailConfirm: true });
      }
      if (
        decryptRes.error !== undefined &&
        decryptRes.error.includes("invalid")
      ) {
        this.setState({ badRequest: true });
      }
      if (
        decryptRes.info !== undefined &&
        decryptRes.info.includes("Duplicate")
      ) {
        this.setState({
          duplicateRequest: true,
          duplicateRequestMsg: decryptRes.info,
        });
      }
      if (
        decryptRes.status === 500 ||
        (decryptRes.fault !== undefined &&
          decryptRes.fault.faultstring.includes("unavailable"))
      ) {
        this.setState({ internalServerError: true });
      }
    } catch (e) {
      console.log(e);
      this.setState({ requestForm: false });
      this.setState({ internalServerError: true });
      return e;
    }
  }

  render() {
    return (
      <div>
        <Header />
        <main>
          {this.state.requestForm ? (
            <CallCenterEmailForm onParentAppCall={this.onParentAppCall} />
          ) : this.state.emailConfirm ? (
            <EmailConfirmation />
          ) : this.state.badRequest ? (
            <BadRequest />
          ) : this.state.internalServerError ? (
            <InternalServerError />
          ) : this.state.duplicateRequest ? (
            <DuplicateRequest
              duplicateRequestMsg={this.state.duplicateRequestMsg}
            />
          ) : (
            <SpinnerLoad />
          )}
          <Footer />
        </main>
      </div>
    );
  }
}

export default CallCenterEmail;
